import React, { ReactNode } from 'react';
import { Glyphicon, ListGroup, ListGroupItem, Panel } from 'react-bootstrap';

interface IProps {
    expanded: boolean,
    onToggle: () => void,
    children: ReactNode
}

export const Help = ({ expanded, onToggle, children }: IProps) => {
    return (
        <Panel style={{ marginBottom: 5 }}>
            <Panel.Heading>
                <Panel.Toggle>Some helpful information...</Panel.Toggle>
                <Panel.Toggle componentClass='a' className='pull-right' style={{ cursor: 'pointer' }}><Glyphicon glyph={expanded ? 'triangle-bottom' : 'triangle-top'} /> {expanded ? 'Show' : 'Hide'}</Panel.Toggle>
            </Panel.Heading>
            <Panel.Collapse onEnter={onToggle} onExit={onToggle}>
                <ListGroup style={{ marginBottom: 0 }}>
                    <ListGroupItem>
                        <div style={{ fontWeight: 550 }}>Included Transplants</div>
                        <div style={{ paddingLeft: 20 }}>All non-waitlist chain end transplants (Paired, Voucher, Remote Direct, NKR Internal Direct, and Internal Directs with Microsites.)</div>
                    </ListGroupItem>
                    {children}
                    <ListGroupItem>
                        <div style={{ fontWeight: 550 }}>Report Range</div>
                        <div style={{ paddingLeft: 20 }}>Uses invoice date to account for lag reporting on direct transplant cases.</div>
                        <div style={{ paddingLeft: 20 }}>When the 'transplanted' toggle is used, then transplanted date is used to further filter the data.</div>
                    </ListGroupItem>
                </ListGroup>
            </Panel.Collapse>
        </Panel>
    );
};
